import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticTimePicker } from "@mui/x-date-pickers/StaticTimePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import {
  AI_setWorkingProject,
  AI_showProjectEmployeeList,
} from "APIs/projectEmployee";
import { AI_getUserData } from "APIs/user";
import CommonButton from "components/common-component/Button";
import NoDataFound from "components/common-component/NoDataFound";
import CommonToolTip from "components/common-component/Tooltip";
import CommonDropDown from "components/common-component/dropdown";
import { useInstance } from "easy-redux-http-call";
import { useAIEventHandler } from "easy-redux-http-call/dist/index";
import moment from "moment";
import { useParams } from "react-router-dom";

const useStyle = makeStyles((theme) => ({
  marginLeft: {
    marginLeft: "20px",
  },
  dialog: {
    position: "absolute",
    top: 50,
    width: 500,
    [theme.breakpoints.between("xs", "sm")]: {
      width: "80%",
    },
  },
  hrDialogTitle: {
    display: "flex",
    gap: "10px",
  },
  hrDialogSubTitle: {
    textAlign: "left",
  },
  hrClosebtn: {
    position: "absolute",
    right: 8,
    top: 8,
    color: theme.palette.grey[500],
  },
  hrmsProjectEmployeeTable: {
    maxHeight: "250px",
    overflowY: "auto",
    width: "100%",
    "&::-webkit-scrollbar": {
      width: "10px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#ff7f50",
      borderRadius: "5px",
    },
    "&::-webkit-scrollbar-thumb:active": {
      backgroundColor: "#ff5733",
    },
  },
  hrClockIcon: {
    color: "#d46b08",
    marginRight: "0.5rem",
  },
  hrSubDialog: {
    display: "flex",
    flexDirection: "column",
    // alignItems: "center"
  },
  hrTimePickerOverlay: {
    "& .css-ypiqx9-MuiDialogContent-root": {
      overflowY: "hidden",
      overflowX: "hidden",
    },
    "&.css-1opbptt-MuiPickersLayout-root .MuiPickersLayout-actionBar": {
      display: "none",
    },
  },
  hrSpan: {
    textAlign: "center",
    fontWeight: "bold",
    display: "flex",
    alignItems: "self-end",
    position: "relative",
    left: "378px",
    bottom: "16px",
    width: "80px",
    cursor: "pointer",
  },
}));
const PunchInOrOut = (props) => {
  const classes = useStyle();
  const { openStatus = false, handleCloseAction = () => {} , selectedProject} = props;
  const getUserData = useInstance(AI_getUserData);
  const projectDetails = useInstance(AI_showProjectEmployeeList);
  const setWorkingPorject = useInstance(AI_setWorkingProject);

  const currentTime = moment().format("HH:mm");
  const ProjectChangeTime = moment().format("HH:mm");

  const [selectedTime, setSelectedTime] = React.useState(currentTime);
 
  const setPunchInTime = selectedTime ? selectedTime : ProjectChangeTime;
  // const [placeholder, setPlaceholder] = React.useState();
  const [openClock, setOpenClock] = React.useState(false);
  const [isWorking, setIsWorking] = React.useState(null);
  const [projectId, setProjectId] = React.useState(null);
  const [flagPid, setFlagPid] = React.useState(true);
  const handleOpenClock = () => {
    const isOpen = openClock == false;
    setOpenClock(isOpen ? true : false);
  };
  
  const handleTimeChange = (newTime) => {
    setSelectedTime(newTime);
  };

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      setSelectedTime(currentTime);
    }, 1000);
    
    return () => {
      clearInterval(intervalId);
    };
  }, [openStatus]);

  const currentTimeForDropdown = moment().format("HH:mm");
  // `${now
  //   .getHours()
  //   .toString()
  //   .padStart(2, "0")}:${now.getMinutes().toString().padStart(2, "0")}`;
  
  const [projectStartTime, setProjectStartTime] = React.useState(
    currentTimeForDropdown
  );
  let { employeeid } = useParams();

  //for dropdown
  const handleChangeInDropDown = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue === "none") {
      setProjectStartTime("none");
    } else {
      setProjectStartTime(selectedValue);
    }
  };
  const defaultProjectStartTime = moment().format("HH:mm:ss");
  const formattedTime = (
    projectStartTime === "none" ? currentTimeForDropdown : projectStartTime
  )
    ? moment(
        projectStartTime === "none" ? currentTimeForDropdown : projectStartTime,
        "hh:mm a"
      ).format("HH:mm:ss")
    : defaultProjectStartTime;

  React.useEffect(() => {
    var checkFirstPunchIn = getUserData?.data?.user?.employee?.first_punch_In;
  }, [openStatus, getUserData]);
  var checkFirstPunchIn = getUserData?.data?.user?.employee?.first_punch_In;
  const showPunchInDropdown = checkFirstPunchIn;

  // DONT DELETE BELOW COMMENTS

  // const ISTOffset = 330;
  // var current = new Date();
  // console.log("current", current);
  // // current.setHours(9,44,0,0)
  // const officeTime = new Date();
  // officeTime.setHours(9, 45, 0, 0);
  // console.log("officeTime", officeTime);
  // const utc = new Date(officeTime.getTime() - ISTOffset * 60000);
  // console.log("utc", utc);
  // var checkPriorOfficeTime; // flag
  // if (current < utc) {
  //   checkPriorOfficeTime = false;
  // } else {
  //   checkPriorOfficeTime = true;
  // }

  const ISTOffset = 330;
  const current = moment();

  const officeTime = moment().startOf("day").add(9, "hours").add(45, "minutes");

  const utc = moment(officeTime).subtract(ISTOffset, "minutes");

  let checkPriorOfficeTime; // flag
  if (current.isBefore(utc)) {
    checkPriorOfficeTime = false;
  } else {
    checkPriorOfficeTime = true;
  }

  // if (current<officeTime) {
  //   checkPriorOfficeTime = false
  // } else {
  //   checkPriorOfficeTime = true
  // }
  const handleSubmit = () => {
    AI_setWorkingProject.call({
      params: {
        project_id: isWorking ? isWorking : selectedProject,
        employee_id: getUserData?.data?.user?.employee_id,
        punchInOut: true,
        // projectStartTime:setPunchInTime.format('HH:mm:ss') // for clock
        projectStartTime: formattedTime, //for dropdown
      },
    });
  };
  // DONT DELETE BELOW COMMENT
  // React.useEffect(() => {
  //   if (getUserData?.data?.user?.employee_id !== undefined) {
  //     AI_showProjectEmployeeList.call({
  //       urlParams: { id: getUserData?.data?.user?.employee_id },
  //       params:{
  //         test:true
  //       }
  //     });
  //   }
  // }, [getUserData]);

  const [debouncedUserData, setDebouncedUserData] = React.useState(getUserData);
  const [apiCalled, setApiCalled] = React.useState(false);
  React.useEffect(() => {
    if (projectDetails?.data?.rows && flagPid) {
      const rows = projectDetails.data.rows;
  
      const workingProjectId = rows.find((pId) => pId.is_working)?.project_id;
  
      if (workingProjectId) {
        localStorage.setItem("projectId", workingProjectId);
      } else if (rows[0]?.project_id) {
        localStorage.setItem("projectId", rows[0].project_id);
      }
    }
  }, [projectDetails]);
  
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedUserData(getUserData);
    }, 500);
    return () => clearTimeout(timer);
  }, [getUserData]);

  React.useEffect(() => {
    if (
      !apiCalled &&
      debouncedUserData?.data?.user?.employee_id !== undefined
    ) {
      setApiCalled(true);
      AI_showProjectEmployeeList.call({
        urlParams: {
          id: employeeid
            ? employeeid
            : debouncedUserData?.data?.user?.employee_id,
        },
      });
    }
  }, [debouncedUserData, apiCalled]);
  useAIEventHandler(AI_setWorkingProject, {
    onSuccess: () => {
      AI_getUserData.call();
      setIsWorking(null);
      handleCloseAction();
      if (getUserData?.data?.user?.employee_id !== undefined) {
        AI_showProjectEmployeeList.call({
          urlParams: {
            id: getUserData?.data?.user?.employee_id,
          },
        });
      }
    },
  });

  const [timeAndDate, setTimeAndDate] = React.useState({
    hours: moment().hours(),
    min: moment().minutes(),
  });

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeAndDate({
        hours: moment().hours(),
        min: moment().minutes(),
      });
    }, [30000]);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  React.useEffect(() => {
    if (!openStatus) {
      setProjectStartTime("");
    }
  }, [openStatus]);

  const handleDisableComplete = (employee) => {
    return (
      employee?.project?.status === "completed & live" ||
      employee?.project?.status === "completed"
    );
  };
  return (
    <Dialog
      open={openStatus}
      onClose={() => {
        setOpenClock(false);
        handleCloseAction();
      }}
      classes={{ paper: classes.dialog }}
      fullWidth
    >
      <form
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
          setOpenClock(false);
        }}
      >
        <DialogTitle>
          <div className={classes.hrDialogTitle}>
            <Typography variant="h4" className={classes.hrDialogSubTitle}>
              Punch In
            </Typography>
          </div>

          <IconButton
            aria-label="close"
            onClick={() => {
              setOpenClock(false);
              handleCloseAction();
            }}
            className={classes.hrClosebtn}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          {/* if user forget to punch in when they Arrived they can set the projectStartTime */}
          {openClock ? (
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DemoContainer
                components={["StaticTimePicker"]}
                className={classes.root}
              >
                <StaticTimePicker
                  orientation="landscape"
                  className={classes.hrTimePickerOverlay}
                  value={selectedTime}
                  onChange={handleTimeChange}
                  ampm={true}
                />
              </DemoContainer>
            </LocalizationProvider>
          ) : (
            <Grid
              style={{
                display: "flex",
                justifyContent: "center",
                fontSize: "50px",
              }}
            >
              {setPunchInTime}
              {/* {setPunchInTime.$H + " : "}
              {setPunchInTime.$m < 10
                ? `0${setPunchInTime.$m}`
                : setPunchInTime.$m} */}
            </Grid>
          )}
          {/* DONT DELETE BELOW CODE ! */}
          {/* <CommonToolTip title="When did you Arrive?">
            <span className={classes.hrSpan} onClick={handleOpenClock}>
              <AccessTimeFilledIcon className={classes.hrClockIcon} />
              {selectedTime.$H + ":"}
              {selectedTime.$m < 10 ? `0${selectedTime.$m}` : selectedTime.$m}
            </span>
          </CommonToolTip> */}
          {showPunchInDropdown && checkPriorOfficeTime && (
            <CommonDropDown
              disabled={
                window.location.pathname === "/personal-details" ? true : false
              }
              selectedValue={projectStartTime}
              name="department_id"
              onChangeAction={(e) => {
                handleChangeInDropDown(e);
              }}
              label="Since when were you in the office?"
              enableTimeOptions={true}
              // error={
              //   touched.department_id &&
              //   errors?.department_id !== undefined
              //     ? true
              //     : false
              // }
              // onBlur={handleBlur}
              // totalListCount={departmentReduxState?.data?.count}
            />
          )}
          <Divider />
          <Grid className={classes.hrmsProjectEmployeeTable}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    Currently Working
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!projectDetails?.data?.rows?.length && projectDetails.loading && (
                  <Typography variant="h6" className={classes.loading}>
                    Fetching data...
                  </Typography>
                )}
                {projectDetails?.data?.rows?.map((employee) => (
                  <>
                    <CommonToolTip
                      title={
                        handleDisableComplete(employee) &&
                        "Kindly request the Project Manager to designate this project as In Progress"
                      }
                    >
                      <TableCell style={{ display: "grid" }}>
                        <FormControl style={{ paddingLeft: "30px" }}>
                          {/* <FormLabel>Curruent Working Project</FormLabel> */}
                          <FormControlLabel
                            value={employee?.project?.title}
                            control={
                              <Checkbox
                                checked={
                                  // selectedProject
                                  //  ? selectedProje
                                  //  : isWorking && isWorking === employee.id
                                  isWorking
                                  ? isWorking && isWorking === employee.id
                                  : selectedProject === employee.id
                                }

                                onChange={(event) => {
                                  if (employee.id === isWorking) {
                                    setIsWorking(null);
                                  } else {
                                    setIsWorking(employee.id);
                                    setProjectId(employee.project_id)
                                    setFlagPid(false)
                                    localStorage.setItem('projectId',employee.project_id)
                                  }
                                }}
                                disabled={handleDisableComplete(employee)}
                              />
                            }
                            label={employee?.project?.title}
                          />
                        </FormControl>
                      </TableCell>
                    </CommonToolTip>
                  </>
                ))}
              </TableBody>
            </Table>
          </Grid>
          {!projectDetails.loading && projectDetails?.data?.rows?.length === 0 && (
            <Grid className={classes.hrNoFound}>
              <NoDataFound />
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          {/* <Button variant="outlined" onClick={() => handleCloseAction()}>
            Cancel
          </Button> */}
          <CommonButton
            variant="contained"
            loading={setWorkingPorject.loading}
            type="submit"
          >
            Submit
          </CommonButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default PunchInOrOut;
